import { subscribeKey } from "valtio/utils";

import { readState } from "@/__main__/app-state.mjs";
import { IS_APP, IS_DEV } from "@/__main__/constants.mjs";
import { setFeatureFlag, setVolatileKV } from "@/app/actions.mjs";
import eventBus from "@/app/app-event-bus.mjs";
import fetchRemoteAdConfig from "@/feature-ads/fetch-remote-ad-config.mjs";
import { promiseTimeout } from "@/feature-ads/util/promise-timeout.mjs";
import { CMS_ACCESS } from "@/feature-auth/constants/constants.mjs";
import { isUserSubscriber } from "@/feature-subscriber/utils/subscriber.mjs";
import { devLog } from "@/util/dev.mjs";
import getOSType from "@/util/get-os-type.mjs";
import globals from "@/util/global-whitelist.mjs";
import hasQueryString from "@/util/has-query-string.mjs";
import isRouteOverlay from "@/util/is-route-overlay.mjs";

// Once we're confident about this, decomission old shiet.
const randomSessionNewAds = !hasQueryString("__OLD_ADS__");
// const randomSessionNewAds = hasQueryString("__NEW_ADS__");
// const randomSessionNewAds = IS_APP || hasQueryString("__NEW_ADS__");
// const randomSessionNewAds =
//   Math.random() < 0.1 || hasQueryString("__NEW_ADS__");

let unsubscribeUser: (() => void) | null = null;

function onUserChange() {
  setAdsFeatureFromUserRoles();
}

export function setAdsFeatureFromUserRoles() {
  if (getOSType() === "mobile") return;
  // Set ads based on user roles.
  let shouldHaveAds = !isUserSubscriber(readState.user);

  if (isRouteOverlay()) {
    devLog("[ads] skipping ads toggle due to overlay route");
    shouldHaveAds = false;
  }

  if (IS_DEV) {
    devLog("[ads] skipping ads toggle due to IS_DEV");
    shouldHaveAds = false;
  }
  if (hasQueryString("__BLITZ_ADS__")) {
    shouldHaveAds = true;
  }

  if (randomSessionNewAds) {
    // ads v2
    setFeatureFlag("adsBaseline", shouldHaveAds);
    setFeatureFlag("adsAditude", shouldHaveAds);

    // conditionally, enable video ads
    (async () => {
      if (!shouldHaveAds) return;
      const adConfig = await promiseTimeout(
        fetchRemoteAdConfig(),
        3000,
        "failed to fetch remote ad config",
      );
      if (
        // if app, check if has country has app video ads enabled
        (IS_APP && adConfig?.videoEnabled) ||
        // if web, check for none mobile device + if has country has web video ads enabled
        (!IS_APP && globals.innerWidth > 768 && adConfig?.videoEnabledWeb)
      ) {
        setFeatureFlag("adsVideo", true);
      }
    })();
  } else {
    // TEMPORARY: DISABLE NEW
    setFeatureFlag("adsBaseline", false);

    // OLD SET, TO BE DEPRECATED
    setFeatureFlag("ads", shouldHaveAds);
    setFeatureFlag("adsProfileVideo", shouldHaveAds);
    setFeatureFlag("adsInfeedBanner", shouldHaveAds);
    setFeatureFlag("adsLr", shouldHaveAds);
    setFeatureFlag("adsInContentBanner", shouldHaveAds);
    setFeatureFlag("adsEnable", shouldHaveAds);
    setFeatureFlag("adsVideo", shouldHaveAds);
    setFeatureFlag("adsOutstream", shouldHaveAds);
  }

  // This is used by feature-ads to notify it when we have confirmed
  // that the user should have ads or not.
  eventBus.emit("shouldHaveAds", shouldHaveAds);

  // Used for checking after the event has fired.
  setVolatileKV("shouldHaveAds", shouldHaveAds || IS_DEV);
}

export function setCMSFeature(): void {
  if (!readState.user?.roles?.some(({ id }) => id === CMS_ACCESS)) return;
  setFeatureFlag("cms", true);
}

export function registerUserRolesSubscription() {
  if (!unsubscribeUser) {
    unsubscribeUser = subscribeKey(readState, "user", onUserChange);
  }
}

export function unregisterUserRolesSubscription() {
  if (unsubscribeUser) unsubscribeUser();
}
